import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
// import { Row, Col } from 'react-bootstrap';
import Committeeleft from './Committeeleft';
import { Container, Row,Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import { Table } from 'react-bootstrap';

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Differently Abled Support Service Cell" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">

                        <Row>

                        <Col md={3} className='c-left custom-padding-color mb-4'>
                        <Committeeleft></Committeeleft>
                        </Col>
                
                        <Col md={9} className='c-right'>

                            
                                <h3 className='c-headline mb-3'>Differently Abled Support Service Cell</h3>
                                <p className='c-lineheight2dot5'>A new cell for the differently abled support services has been constituted with the following members:  </p>

                                {/* <Link className='c-link' to="icc@iittp.ac.in" target="_blank" >icc@iittp.ac.in </Link> */}

                                <Table bordered responsive className='mt-3'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>Dr. Sriram Sundar</p>
                                                <p>Associate Professor - Department of Mechanical Engineering </p>
                                            </td>
                                            <td>Nodal Officer</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Durga Prasad Challa</p>
                                                <p>Associate Professor<br />
                                                Chairperson - Admissions
                                                </p>
                                            </td>
                                            <td>Member Ex-officio</td>
                                        </tr>

                                        {/*<tr>
                                            <td>
                                                <p>Mr. Mohammad Ishaq Alikhan</p>
                                                <p>Junior Superintendent - Admissions</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>*/}

                                        <tr>
                                            <td>
                                                <p>Mr. Madhu N</p>
                                                <p>Assistant Registrar - Admissions</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Prof. NN Murty</p>
                                                <p>Professor<br />Dean - Student Affairs</p>
                                            </td>
                                            <td>Member Ex-officio</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. P Neeraja</p>
                                                <p>Counsellor</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mr. M Venkat Ramana</p>
                                                <p>Assistant Registrar - Student Affairs</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Prof. Muthukumar Palanisamy</p>
                                                <p>Professor</p>
                                            </td>
                                            <td>Member Ex-officio</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Mr. Harikrishna Reddy</p>
                                                <p>Assistant Registrar - Academic Section</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Mrs. Sandhya Y</p>
                                                <p>Section Officer - Academic Section</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Prof. Venkata Ramana Badarla</p>
                                                <p>Professor<br />Head - Computer Centre</p>
                                            </td>
                                            <td>Member Ex-officio</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Mr. P Vamshi Seshasayan</p>
                                                <p>Technical Officer - Computer Centre</p>
                                            </td>
                                            <td>Member </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Mr. T. Senthil</p>
                                                <p>Technical Superintendent - Computer Centre</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Dr. Subbareddy Daggumati</p>
                                                <p>Associate Professor<br />Advisor - Placements</p>
                                            </td>
                                            <td>Member Ex-officio</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Mr. J Prabha Kiran</p>
                                                <p>Placement Officer</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Mr. Abhinay Irala</p>
                                                <p>Training and Placement Officer</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                    </tbody>

                                </Table>

                               


                                <p className='fw-bold c-headline caboutus mt-3 mb-3'>The cell is responsible for supporting students with specific learning disabilities (SLD) and persons with disabilities (PwD) students. The broad responsibilities of the Cell are as follows:</p>
                                <ul className='ms-3 c-lineheight2dot5 iarrow caboutus' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Identifying students with SLD and PwD and assessing their needs.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	Providing accommodations and support services, such as extra time for exams, note-takers, or assistive technology. </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	Developing Individualized Learning Plans (ILPs) or Individualized Education Programs (IEPs) for such students. </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	Raising awareness about SLD among faculty, staff, and students, and providing training on supporting such students.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Offering counselling and guidance to students with SLD to help them cope with their challenges. </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	Collaborating with faculty members to adapt curricula, teaching methods, and assessments to meet the needs of students with learning disabilities. </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Monitoring the progress of such students and adjusting support services as needed. </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Referring students to external resources, such as tutoring services, counselling, or disability support organizations. </li>
                                </ul>

                                </Col>

                           
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;